var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowReduce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65008 13C7.65008 12.641 7.35906 12.35 7.00007 12.35L1.15 12.35C0.79101 12.35 0.499991 12.641 0.499991 13C0.499991 13.359 0.79101 13.65 1.15 13.65L6.35006 13.65L6.35006 18.8499C6.35006 19.2089 6.64108 19.4999 7.00007 19.4999C7.35906 19.4999 7.65008 19.2089 7.65008 18.8499L7.65008 13ZM7.45963 13.4597L7.4597 13.4596L6.54045 12.5404L6.54037 12.5404L7.45963 13.4597Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3499 7.00013C12.3499 7.35911 12.6409 7.65012 12.9999 7.65012L18.85 7.65012C19.209 7.65012 19.5 7.35911 19.5 7.00013C19.5 6.64115 19.209 6.35014 18.85 6.35014L13.6499 6.35014L13.6499 1.1502C13.6499 0.791223 13.3589 0.500211 12.9999 0.500211C12.6409 0.500211 12.3499 0.791223 12.3499 1.1502L12.3499 7.00013ZM12.5404 6.54045L12.5403 6.54052L13.4596 7.45975L13.4596 7.45967L12.5404 6.54045Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowReduce);
export default __webpack_public_path__ + "static/media/arrow-reduce.69cc7d34ef29a5d6fea6ddca2aafd1f9.svg";
export { ForwardRef as ReactComponent };